<div class="row common-file-dropbox-component" [formGroup]="form">
  <div class="col-8 d-flex upload-window justify-content-center" [class.full-width]="fullWidth">
    @if (fileUploaded === undefined) {
      <div class="dropzone w-100" appFileDrop (filesDropped)="filesDropped($event)">
        <div class="row py-1">
          <div class="col">
            <ds-icon
              class="upload-icon"
              [icon]="Icons.ArrowUpFromBracket"
              [iconStyle]="IconStyles.Light"
              [scale]="IconScale.FA_2X"
            ></ds-icon>
          </div>
        </div>
        <div class="row py-1">
          <div class="col d-flex justify-content-center">
            <button
              ds-button
              [variant]="DsButtonVariants.secondary"
              data-test-id="add-file-btn"
              #addFileButton
              type="button"
              (click)="nativeInput.click()"
            >
              {{ 'label_add_file' | translate }}
            </button>
            <input
              type="file"
              name="bulkUpload"
              (change)="filesChosen($event)"
              hidden
              #nativeInput
              formControlName="bulkUpload"
              [accept]="acceptedFileTypes.join(',')"
            />
          </div>
        </div>
        <div class="row py-1">
          <div class="col">
            {{ 'label_add_or_drop_file' | translate }}
          </div>
        </div>
        @if (helperText) {
          <div class="row py-1">
            <div class="col" data-test-id="file-helper-text">{{ helperText | translate }}</div>
          </div>
        }
        @if (fileDropError !== undefined) {
          <div class="row">
            <div class="col red-fill">
              {{ fileDropError | translate }}
            </div>
          </div>
        }
        @if (fileValid === false) {
          <div class="row pt-2">
            <div
              class="col-12"
              [class.text-start]="hasDefaultCorrectFieldsText"
              [class.text-center]="!hasDefaultCorrectFieldsText"
            >
              @if (correctFieldsText) {
                <p>
                  @if (hasDefaultCorrectFieldsText) {
                    <b>{{ correctFieldsText | translate }}</b>
                  } @else {
                    {{ correctFieldsText | translate }}
                  }
                </p>
              }
            </div>
          </div>
        }
        @if (fileValid === false) {
          <div class="row justify-content-center">
            <div class="col-12 justify-content-center">
              <ng-container *ngTemplateOutlet="errorTable"></ng-container>
            </div>
          </div>
        }
      </div>
    }

    @if (fileUploaded === false) {
      <div class="dropzone w-100">
        <div class="row p-1 justify-content-center">
          <div class="col-auto">
            <app-common-name-tag (closeButtonClicked)="cancelFile()" [fileName]="file.name" [redBorder]="false">
            </app-common-name-tag>
          </div>
          <div class="col-auto">
            <button class="btn button-link-style" type="button" (click)="cancelFile()">{{ 'form_cancel' | translate }}</button>
          </div>
        </div>
        <div class="row p-2">
          <div class="col-12 d-flex justify-content-center">
            <button
              ds-button
              [variant]="DsButtonVariants.primary"
              data-test-id="upload-file-btn"
              #uploadButton
              type="button"
              (click)="validate($event)"
            >
              {{ 'upload_action_upload' | translate }}
            </button>
          </div>
        </div>
      </div>
    }

    @if (fileUploaded === true && fileValid === true && file) {
      <div class="dropzone w-100">
        <div class="row">
          <div class="col-12">
            <p>
              <b>{{ 'label_file_successfully_uploaded' | translate }}</b>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>{{ fileUploadedMessage | translate }}</p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-auto">
            <app-common-name-tag (closeButtonClicked)="cancelFile()" [fileName]="file.name" [redBorder]="false">
              <ds-icon
                statusIcon
                class="name-tag-icon green-fill"
                [icon]="Icons.CircleCheck"
                [iconStyle]="IconStyles.Light"
              ></ds-icon>
            </app-common-name-tag>
          </div>
          <div class="col-auto">
            <button class="btn button-link-style" type="button" (click)="cancelFile()">{{ 'label_replace' | translate }}</button>
          </div>
        </div>
      </div>
    }

    @if (fileUploaded === true && fileValid === false) {
      <div class="dropzone w-100">
        <div class="row">
          <div class="col-12">
            <p>
              <b
                tabindex="-1"
                #failureHeadingElement
                data-test-id="file-failure-heading"
                [class.red-fill]="failureHeading !== undefined"
                >{{ failureHeading ?? 'label_invalid_missing_information' | translate }}</b
              >
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="red-fill">{{ fileDataError | translate }}</p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-auto">
            <app-common-name-tag (closeButtonClicked)="cancelFile()" [fileName]="file.name" [redBorder]="true">
              <ds-icon
                statusIcon
                class="name-tag-icon red-fill"
                [icon]="Icons.CircleExclamation"
                [iconStyle]="IconStyles.Light"
              ></ds-icon>
            </app-common-name-tag>
          </div>
          <div class="col-auto">
            <button class="btn button-link-style" type="button" (click)="cancelFile()">{{ 'label_replace' | translate }}</button>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-12" [class.text-start]="hasDefaultCorrectFieldsText" [class.text-center]="!hasDefaultCorrectFieldsText">
            @if (correctFieldsText) {
              <p>
                @if (hasDefaultCorrectFieldsText) {
                  <b>{{ correctFieldsText | translate }}</b>
                } @else {
                  {{ correctFieldsText | translate }}
                }
              </p>
            }
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-12">
            <ng-container *ngTemplateOutlet="errorTable"></ng-container>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #errorTable>
  <ng-content select="[errorTable]"> </ng-content>
</ng-template>
